import styled from "styled-components";
import colors from "@styling/colors";

type LoadingSpinnerProps = {
  size?: number;
  borderWidth?: number;
  centered?: boolean;
  className?: string;
};

const Spinner = styled.div<{ $size: number; $borderWidth: number; $centered: boolean }>`
  border: ${({ $borderWidth }) => $borderWidth}px solid ${colors.border};
  border-top: ${({ $borderWidth }) => $borderWidth}px solid ${colors.primary};
  border-radius: 50%;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  animation: spin 1s linear infinite;
  ${({ $centered }) => $centered && "margin: 0 auto;"}

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingSpinner = ({ 
  size = 40, 
  borderWidth = 3, 
  centered = false,
  className 
}: LoadingSpinnerProps) => {
  return (
    <Spinner 
      $size={size} 
      $borderWidth={borderWidth} 
      $centered={centered}
      className={className}
    />
  );
};

